var _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgElements2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 957,
    viewBox: "0 0 1440 957",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2558_61109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1222.03 159.546C1215.12 133.338 1230.71 106.475 1256.87 99.546C1283.02 92.6167 1309.82 108.245 1316.73 134.453C1323.65 160.661 1308.05 187.524 1281.9 194.453C1255.75 201.382 1228.95 185.754 1222.03 159.546Z",
    fill: "url(#paint0_linear_2558_61109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.44 145.958C1218.44 145.958 1213.48 147.445 1204.91 150.592C1200.63 152.194 1195.49 154.196 1189.73 156.885C1182.99 159.675 1176.74 163.539 1171.23 168.326C1170.29 169.165 1169.52 170.184 1168.97 171.323C1168.42 172.462 1168.11 173.699 1168.04 174.962C1167.96 175.417 1167.96 175.881 1168.04 176.335V177.022C1168.43 177.761 1168.95 178.42 1169.58 178.967C1170.56 179.798 1171.68 180.455 1172.89 180.912C1177.26 182.358 1181.82 183.13 1186.42 183.2C1195.96 183.498 1205.5 183.001 1214.96 181.713C1235.35 179.033 1255.56 175.078 1275.47 169.871C1295.22 164.586 1314.63 158.071 1333.58 150.363C1342.39 146.918 1350.91 142.747 1359.03 137.892C1363.01 135.48 1366.59 132.47 1369.65 128.967C1370.46 127.975 1371.1 126.853 1371.54 125.649C1371.84 124.935 1372 124.167 1372 123.39C1372 122.613 1371.84 121.844 1371.54 121.13C1370.87 119.909 1369.86 118.913 1368.62 118.27C1367.63 117.716 1366.58 117.275 1365.49 116.954C1358.22 115.454 1350.75 115.165 1343.39 116.096C1337.06 116.668 1331.58 117.411 1327.07 118.155C1318.11 119.642 1313.03 120.844 1313.03 120.844C1313.03 120.844 1318.16 120.215 1327.24 119.471C1331.98 119.07 1337.69 118.727 1343.68 118.613C1350.57 118.38 1357.47 119.093 1364.17 120.729C1364.88 120.929 1365.57 121.198 1366.23 121.53C1366.49 121.655 1366.72 121.83 1366.91 122.045C1367.04 122.244 1367.16 122.455 1367.25 122.674C1367.71 123.247 1367.25 124.677 1365.88 126.05C1363.13 128.946 1359.98 131.432 1356.52 133.43C1348.39 137.757 1340.01 141.578 1331.41 144.871C1312.59 152.196 1293.33 158.348 1273.75 163.292C1254.3 168.692 1234.53 172.876 1214.56 175.82C1205.45 177.191 1196.26 177.994 1187.05 178.223C1179 178.223 1167.24 176.907 1173.97 170.786C1179.11 166.088 1184.88 162.122 1191.1 159.001C1196.81 155.969 1201.54 153.567 1205.71 151.679C1213.65 148.017 1218.44 145.958 1218.44 145.958Z",
    fill: "url(#paint1_linear_2558_61109)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.742 292.674L341.75 168.27C342.15 167.92 342.374 167.446 342.374 166.952C342.374 166.459 342.15 165.985 341.75 165.635C341.373 165.263 340.842 165.037 340.274 165.004C339.705 164.972 339.144 165.136 338.715 165.461L178.034 285.113C177.446 285.548 176.965 286.081 176.618 286.68C176.271 287.278 176.065 287.932 176.013 288.6C175.961 289.269 176.064 289.941 176.315 290.575C176.566 291.209 176.96 291.793 177.475 292.292C177.984 292.795 178.604 293.205 179.298 293.497C179.992 293.789 180.746 293.957 181.516 293.993C182.286 294.028 183.057 293.93 183.782 293.704C184.508 293.477 185.175 293.127 185.742 292.674Z",
    fill: "url(#paint2_linear_2558_61109)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M243.896 245.057L339.753 168.861C339.878 168.754 339.977 168.627 340.044 168.488C340.111 168.348 340.146 168.197 340.146 168.046C340.146 167.894 340.111 167.744 340.044 167.604C339.977 167.464 339.878 167.337 339.753 167.231C339.507 167.023 339.178 166.907 338.835 166.907C338.492 166.907 338.162 167.023 337.916 167.231L239.343 240.444C238.981 240.71 238.685 241.036 238.471 241.403C238.256 241.77 238.129 242.17 238.095 242.58C238.062 242.991 238.123 243.403 238.276 243.792C238.428 244.182 238.669 244.541 238.983 244.848C239.613 245.426 240.476 245.771 241.392 245.809C242.307 245.848 243.204 245.578 243.896 245.057Z",
    fill: "url(#paint3_linear_2558_61109)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1281.26 241.832L1371.64 192.497C1371.87 192.357 1372 192.17 1372 191.974C1372 191.778 1371.87 191.59 1371.64 191.451C1371.42 191.304 1371.11 191.214 1370.78 191.201C1370.45 191.188 1370.13 191.253 1369.88 191.382L1276.8 238.833C1276.46 239.006 1276.18 239.217 1275.98 239.455C1275.77 239.692 1275.66 239.951 1275.63 240.216C1275.6 240.482 1275.65 240.748 1275.8 240.999C1275.95 241.251 1276.17 241.482 1276.47 241.681C1276.77 241.88 1277.13 242.042 1277.53 242.158C1277.93 242.274 1278.37 242.341 1278.81 242.355C1279.26 242.369 1279.71 242.33 1280.13 242.24C1280.55 242.15 1280.93 242.012 1281.26 241.832Z",
    fill: "url(#paint4_linear_2558_61109)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1314.95 222.948L1370.48 192.731C1370.55 192.688 1370.61 192.638 1370.65 192.583C1370.69 192.527 1370.71 192.468 1370.71 192.407C1370.71 192.347 1370.69 192.288 1370.65 192.232C1370.61 192.177 1370.55 192.126 1370.48 192.084C1370.34 192.002 1370.15 191.956 1369.95 191.956C1369.75 191.956 1369.56 192.002 1369.42 192.084L1312.31 221.119C1312.1 221.224 1311.93 221.354 1311.81 221.499C1311.68 221.645 1311.61 221.803 1311.59 221.966C1311.57 222.129 1311.61 222.292 1311.69 222.447C1311.78 222.601 1311.92 222.744 1312.1 222.866C1312.47 223.095 1312.97 223.231 1313.5 223.247C1314.03 223.262 1314.55 223.155 1314.95 222.948Z",
    fill: "url(#paint5_linear_2558_61109)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.412 955.406L344.621 805.93C345.101 805.508 345.371 804.939 345.371 804.346C345.371 803.753 345.101 803.184 344.621 802.762C344.169 802.316 343.532 802.044 342.849 802.005C342.167 801.966 341.494 802.163 340.979 802.554L148.162 946.322C147.457 946.845 146.879 947.485 146.463 948.204C146.046 948.924 145.8 949.708 145.737 950.512C145.675 951.316 145.797 952.122 146.099 952.884C146.4 953.646 146.873 954.348 147.491 954.948C148.102 955.552 148.846 956.044 149.679 956.395C150.511 956.746 151.416 956.949 152.34 956.991C153.265 957.034 154.189 956.916 155.06 956.644C155.931 956.372 156.731 955.951 157.412 955.406Z",
    fill: "url(#paint6_linear_2558_61109)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M227.197 898.192L342.226 806.639C342.375 806.511 342.493 806.359 342.574 806.191C342.655 806.022 342.697 805.842 342.697 805.66C342.697 805.478 342.655 805.297 342.574 805.129C342.493 804.961 342.375 804.808 342.226 804.68C341.93 804.431 341.535 804.291 341.123 804.291C340.711 804.291 340.316 804.431 340.021 804.68L221.733 892.65C221.299 892.969 220.943 893.361 220.686 893.802C220.429 894.243 220.276 894.724 220.236 895.217C220.196 895.71 220.269 896.205 220.452 896.673C220.635 897.141 220.924 897.572 221.301 897.942C222.058 898.636 223.093 899.05 224.191 899.097C225.29 899.143 226.367 898.819 227.197 898.192Z",
    fill: "url(#paint7_linear_2558_61109)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M661.001 864.746L809.477 747.093C809.858 746.761 810.072 746.313 810.072 745.847C810.072 745.38 809.858 744.932 809.477 744.6C809.119 744.249 808.613 744.035 808.072 744.004C807.531 743.973 806.997 744.129 806.588 744.436L653.665 857.595C653.105 858.007 652.647 858.51 652.317 859.077C651.987 859.643 651.791 860.261 651.742 860.893C651.692 861.526 651.789 862.161 652.028 862.76C652.267 863.36 652.643 863.912 653.132 864.385C653.617 864.86 654.207 865.248 654.868 865.524C655.528 865.8 656.246 865.96 656.979 865.993C657.712 866.027 658.445 865.934 659.136 865.72C659.826 865.505 660.461 865.174 661.001 864.746Z",
    fill: "url(#paint8_linear_2558_61109)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M716.348 819.713L807.577 747.651C807.696 747.551 807.79 747.431 807.854 747.298C807.918 747.166 807.951 747.024 807.951 746.881C807.951 746.737 807.918 746.595 807.854 746.463C807.79 746.331 807.696 746.211 807.577 746.11C807.343 745.913 807.03 745.804 806.703 745.804C806.377 745.804 806.063 745.913 805.829 746.11L712.014 815.35C711.67 815.602 711.388 815.91 711.184 816.257C710.98 816.604 710.859 816.983 710.827 817.371C710.795 817.759 710.853 818.149 710.998 818.517C711.144 818.885 711.373 819.225 711.672 819.516C712.272 820.062 713.093 820.388 713.964 820.425C714.835 820.461 715.689 820.206 716.348 819.713Z",
    fill: "url(#paint9_linear_2558_61109)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M841.145 925.746L989.621 808.093C990.002 807.761 990.215 807.313 990.215 806.847C990.215 806.38 990.002 805.932 989.621 805.6C989.262 805.249 988.757 805.035 988.216 805.004C987.674 804.973 987.141 805.129 986.732 805.436L833.808 918.595C833.249 919.007 832.791 919.51 832.461 920.077C832.13 920.643 831.935 921.261 831.885 921.893C831.836 922.526 831.933 923.161 832.172 923.76C832.411 924.36 832.786 924.912 833.276 925.385C833.761 925.86 834.351 926.248 835.011 926.524C835.672 926.8 836.389 926.96 837.122 926.993C837.855 927.027 838.589 926.934 839.279 926.72C839.97 926.505 840.604 926.174 841.145 925.746Z",
    fill: "url(#paint10_linear_2558_61109)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M896.491 880.713L987.721 808.651C987.839 808.551 987.933 808.431 987.997 808.298C988.062 808.166 988.095 808.024 988.095 807.881C988.095 807.737 988.062 807.595 987.997 807.463C987.933 807.331 987.839 807.211 987.721 807.11C987.487 806.913 987.173 806.804 986.847 806.804C986.52 806.804 986.206 806.913 985.972 807.11L892.158 876.35C891.814 876.602 891.532 876.91 891.328 877.257C891.124 877.604 891.002 877.983 890.97 878.371C890.939 878.759 890.997 879.149 891.142 879.517C891.287 879.885 891.516 880.225 891.816 880.516C892.415 881.062 893.236 881.388 894.108 881.425C894.979 881.461 895.833 881.206 896.491 880.713Z",
    fill: "url(#paint11_linear_2558_61109)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2558_61109",
    x1: 1316.73,
    y1: 134.453,
    x2: 1222.01,
    y2: 159.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F2",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2558_61109",
    x1: 1269.99,
    y1: 115.562,
    x2: 1269.99,
    y2: 183.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2558_61109",
    x1: 342.282,
    y1: 165.486,
    x2: 198.59,
    y2: 312.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2558_61109",
    x1: -103130,
    y1: 59347.3,
    x2: -99687.5,
    y2: 59347.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EFF0F2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2558_61109",
    x1: 1371.95,
    y1: 191.392,
    x2: 1319.25,
    y2: 270.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2558_61109",
    x1: -58570.6,
    y1: 23661.4,
    x2: -56576.4,
    y2: 23661.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EFF0F2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2558_61109",
    x1: 345.26,
    y1: 802.584,
    x2: 172.601,
    y2: 978.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2558_61109",
    x1: -123821,
    y1: 71912.5,
    x2: -119691,
    y2: 71912.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EFF0F2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2558_61109",
    x1: 809.984,
    y1: 744.46,
    x2: 674.111,
    y2: 884.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2558_61109",
    x1: -97667.1,
    y1: 56714.8,
    x2: -94390.8,
    y2: 56714.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EFF0F2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2558_61109",
    x1: 990.127,
    y1: 805.46,
    x2: 854.254,
    y2: 945.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2558_61109",
    x1: -97487,
    y1: 56775.8,
    x2: -94210.7,
    y2: 56775.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EFF0F2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2558_61109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 120,
    fill: "white",
    transform: "matrix(-1 0 0 1 1372 87)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgElements2);
export default __webpack_public_path__ + "static/media/bg_elements_2.3e843a6d8324c1e4b7a408e8366f923e.svg";
export { ForwardRef as ReactComponent };